<script setup>
import { ref, computed } from "vue";
import {
  Icon,
  Accordion,
  Select,
  Input,
  ColorPickerDefault,
} from "@components";
import OptionButton from "./OptionButton.vue";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

import { useSettings } from "@store/settings";
const $settings = useSettings();

const activeAccordion = ref("Button");

const toggleAccordion = (title) => {
  if (activeAccordion.value == title) {
    activeAccordion.value = "";
  } else {
    activeAccordion.value = title;
  }
  console.log(title);
  //   if (title == "Typography") {
  //     return router.push({
  //       name: "customizer.form.overview",
  //       query: { ...route.query },
  //     });
  //   } else {
  //     return router.push({
  //       name: "customizer.form.account",
  //       query: { ...route.query },
  //     });
  //   }
};

const fonts = computed(() => {
  return Object.entries(prebook_admin.options.fonts).map(([key, value]) => {
    return {
      value: key,
      label: `<span style="font-family: '${value}' !important;">${key}</span>`,
    };
  });
});
</script>

<template>
  <div>
    <!-- button section -->
    <Accordion
      leftIcon="cursorBox"
      title="Button"
      :isOpen="activeAccordion == 'Button'"
      @click="toggleAccordion('Button')"
    >
      <div>
        <div class="flex items-center justify-between mb-2">
          <div class="text-[#101828] font-medium text-sm">Button Text</div>
          <!-- <input type="color" v-model="$settings.customizer.design.button_text_color" class="w-6"> -->
          <ColorPickerDefault
            v-model="
              $settings.settings.chat_widget.customizer.design.button_text_color
            "
            class="w-6"
          />
        </div>

        <div class="grid grid-cols-3 gap-3">
          <OptionButton
            @click="
              $settings.settings.chat_widget.customizer.design.button_text_weight =
                style.name
            "
            v-for="style in [
              { name: 'Medium', class: '!font-medium m-auto' },
              { name: 'SemiBold', class: '!font-semibold m-auto' },
              { name: 'Bold', class: '!font-bold m-auto' },
            ]"
            :key="style.name"
            :title="style.name"
            :icon="style.icon"
            size="sm"
            :textClass="style.class"
            :active="
              $settings.settings.chat_widget.customizer.design
                .button_text_weight == style.name
            "
          />
        </div>
      </div>

      <div>
        <div class="flex items-center justify-between mb-2">
          <div class="text-[#101828] font-medium text-sm">
            Button Background
          </div>
          <!-- <input type="color" v-model="$settings.customizer.design.button_background_color" class="w-6"> -->
          <ColorPickerDefault
            v-model="
              $settings.settings.chat_widget.customizer.design
                .button_background_color
            "
            class="w-6"
          />
        </div>

        <div class="grid grid-cols-2 gap-3 mt-2 mb-[16px]">
          <OptionButton
            @click="
              $settings.settings.chat_widget.customizer.design.button_background_style =
                style.name
            "
            v-for="style in [
              { name: 'Filled', icon: 'filled' },
              { name: 'Border', icon: 'border' },
            ]"
            :key="style.name"
            :title="style.name"
            :icon="style.icon"
            size="md"
            :active="
              $settings.settings.chat_widget.customizer.design
                .button_background_style == style.name
            "
            :iconStyle="`color:${$settings.settings.chat_widget.customizer.design.button_background_color} !important;`"
          />
        </div>
      </div>
      <div>
        <div class="text-[#101828] font-medium text-sm mb-2">
          Rounded Corner (PX)
        </div>

        <Input
          type="number"
          v-model="
            $settings.settings.chat_widget.customizer.design
              .button_border_radius
          "
          :min="0"
          :max="100"
          iconLeft="minus"
          iconRight="plus"
          @iconLeftClick="
            $settings.settings.chat_widget.customizer.design
              .button_border_radius--
          "
          @iconRightClick="
            $settings.settings.chat_widget.customizer.design
              .button_border_radius++
          "
          inputClass="text-center !w-[calc(100%-64px)]"
          inputContainerClass="!px-3 !h-12"
          iconLeftClass="text-[#344054] hover:bg-[#F2F4F7] rounded-full p-1 !w-8 !h-auto cursor-pointer"
          iconRightClass="text-[#344054] hover:bg-[#F2F4F7] rounded-full p-1 !w-8 !h-auto cursor-pointer"
        ></Input>
      </div>
    </Accordion>
  </div>
</template>

<style></style>
